<rti-kiwi-hr-promo-dashboard
  [theme]="theme()!"
  (close)="onKiwiBannerClose()"
  (ctaClick)="onKiwiBannerCtaClick()"
/>
